module.exports = __webpack_public_path__ + "img/signin_icon__delete_normal.55644a7f.svg";